export default function ConditionalWrapper({ children, condition, wrapper }) {
  return condition ? wrapper(children) : children;
}
